import { Error } from "@livechat/design-system-icons";
import { IPickerListItem } from "@livechat/design-system-react-components";

export const FILTER_LOGGED_IN_AGENT_KEY = "ME";

const createRemovedOption = (id: string, name: string): IPickerListItem => ({
  key: id,
  name,
  icon: Error,
  selectedTagOptions: { kind: "error" },
});

export const createRemovedAgentOption = (agentId: string): IPickerListItem =>
  createRemovedOption(agentId, "Agent removed");

export const createRemovedFollowerOption = (followerId: string): IPickerListItem =>
  createRemovedOption(followerId, "Follower removed");

export const createRemovedTagOption = (tagId: string): IPickerListItem => createRemovedOption(tagId, "Tag removed");

export const createRemovedTeamOption = (teamId: string): IPickerListItem => createRemovedOption(teamId, "Team removed");
